import React, { useContext, useEffect, useState } from 'react';
import './params.sass';
import '../../../i18n';
import { getLocaleDatePicker } from '../../../utils/datePicker';
import { Trans, useTranslation } from 'react-i18next';
import { RestApiClientContext } from 'src/hooks/context/pageContext';
import {
    ButtonsCustom,
    DrawerCustom,
    FontIconsCustom,
    FormCustom,
    ParagraphCustom,
    PopoverCustom,
    SwitchCustomPro,
    TableCustom,
    TitleCustom,
} from 'src/components/custom';
import ReactHtmlParser from 'react-html-parser';
import { Editor } from '@tinymce/tinymce-react';
import {
    Alert,
    Button,
    DatePicker,
    Divider,
    Form,
    Input,
    InputNumber,
    Modal,
    Radio,
    Skeleton,
    Space,
    Switch,
    Tabs,
    Typography,
    Upload,
} from 'antd';
import { EditParams } from './editRegimen/editParams';
import { faEdit, faEllipsisV, faPlus, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { KnowUsCfg } from 'src/models/knowUs/KnowUsCfg';
import {
    CheckCircleFilled,
    ExclamationCircleOutlined,
    EyeInvisibleOutlined,
    EyeTwoTone,
    LeftOutlined,
    LoadingOutlined,
} from '@ant-design/icons';
import { useAcademy } from 'src/models/academy/academy';
import { showNotification } from 'src/utils/notificationsGeneric';
import { LangContext } from 'src/hooks/context/lang';
export const JPEG_TYPE: string = 'image/jpeg';
export const JPG_TYPE: string = 'image/jpg';
export const PNG_TYPE: string = 'image/png';
export const WEBP_TYPE: string = 'image/webp';
export const SVG_TYPE: string = 'image/svg+xml';
export const ICON_TYPE: string = 'image/x-icon';
export const GIF_TYPE: string = 'image/gif';
import { v4 as uuidv4 } from 'uuid';
import { FormattedNumber } from 'react-intl';
import moment from 'moment';

interface ParamsItems {
    positions: PositionsItems[];
}

interface PositionsItems {
    id: string;
    name: string;
    identityCode: number;
    positionsTranslations: { idLanguage: string; name: string }[];
}

interface OtherConfig {
    mandatoryCompanyName: boolean;
    allowDuplicateLocatorReservations: boolean;
    ranking: {
        showRankingInWebAgents: boolean;
        showMyPositionInWebAgents: boolean;
    };
    noIndexNoFollow: boolean;
    showBillingInfo: boolean;
    isOtpActive: boolean;
    blockNewBookings: boolean;
}
export interface Texts {
    title?: string | null;
    subtitle?: string | null;
    body?: string | null;
}
export interface LandingTraduction {
    idHomeLanding?: string | null;
    language?: any | null;
    multimedia?: string | null;
    idResourceType?: string | null;
    texts: Texts;
    imageName?: string | null;
    base64Image?: string | null;
    imageContentType?: string | null;
    link?: string | null;
}
export interface Landing {
    idHomeLanding?: string | null;
    idResourceType?: string | null;
    orderLanding?: number | null;
    landingTraduction?: LandingTraduction[];
}
export interface WebbConfig {
    language: string | null;
    brandName: string | null;
    incentiveSiteName: string | null;
    passwordExcel: string | null;
    colorWa: string | null;
    colorBo: string | null;
    email: string | null;
    emailInvoice: string | null;
    landings: Landing[];
    logoWa: {
        imageName?: string | null;
        base64Image?: string | null;
        imageContentType?: string | null;
        link?: string | null;
    };
    logoBO: {
        imageName?: string | null;
        base64Image?: string | null;
        imageContentType?: string | null;
        link?: string | null;
    };
    favicon: {
        imageName?: string | null;
        base64Image?: string | null;
        imageContentType?: string | null;
        link?: string | null;
    };
    couponLogoEmail: {
        imageName?: string | null;
        base64Image?: string | null;
        imageContentType?: string | null;
        link?: string | null;
    };
    customerLogoScreen: {
        imageName?: string | null;
        base64Image?: string | null;
        imageContentType?: string | null;
        link?: string | null;
    };
}
interface EmailConfig {
    id: string;
    host: string;
    port: string;
    enableSsl: boolean;
    email: string;
    username: string;
    password: string;
    useWindowsAuthentication: boolean;
    defaultCfg: boolean;
    isActive: boolean;
}
export const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file);
    });
};
export const Params = () => {
    const { t } = useTranslation(['config', 'advancedretributiontranslations']);
    const language = useContext(LangContext);
    const userLang = language.GetLangContext();
    const academyContext = useAcademy();
    const restApiClient = useContext(RestApiClientContext);
    const [listExchange, setListExchange] = useState([]);
    const [loadingSkeleton, setLoadingSkeleton] = useState<boolean>(true);
    const [loadingParams, setLoadingParams] = useState<boolean>(true);
    const [selectedPositionId, setSelectedPositionId] = useState(null);
    const [drawerChoices, setDrawerChoices] = useState([]);
    const [dataParams, setDataParams] = useState<ParamsItems>(null);
    const [visibleDrawer, setVisibleDrawer] = useState(false);
    const [emailNotificationItems, setEmailNotificationItems] = useState<EmailConfig[]>();
    const local = getLocaleDatePicker();
    const emailNotificationDefault = React.useMemo(() => {
        return emailNotificationItems?.find((item) => item?.isActive)?.id;
    }, [emailNotificationItems]);
    const [webConfig, setWebConfig] = useState<WebbConfig>({
        language: null,
        brandName: null,
        incentiveSiteName: null,
        passwordExcel: null,
        colorWa: null,
        colorBo: null,
        email: null,
        emailInvoice: null,
        favicon: {
            imageName: null,
            base64Image: null,
            imageContentType: null,
            link: null,
        },
        logoBO: {
            imageName: null,
            base64Image: null,
            imageContentType: null,
            link: null,
        },
        logoWa: {
            imageName: null,
            base64Image: null,
            imageContentType: null,
            link: null,
        },
        couponLogoEmail: {
            imageName: null,
            base64Image: null,
            imageContentType: null,
            link: null,
        },
        customerLogoScreen: {
            imageName: null,
            base64Image: null,
            imageContentType: null,
            link: null,
        },
        landings: [],
    });
    const scrollLib = require('react-scroll');
    const scroll = scrollLib.animateScroll;
    const [form] = Form.useForm();
    const [formKowUs] = Form.useForm();
    const [formRanking] = Form.useForm();
    const [formWeb] = Form.useForm();
    const [generalData, setGeneralData] = useState<any>({});
    const [modalDeleteLandingTraduction, setModalDeleteLandingTraduction] = useState<{
        id: string;
        language: string;
    }>(undefined);
    const [openDeleteModalSection, setOpenDeleteModalSection] = useState<string>(undefined);
    const [editWebConfig, setEditWebConfig] = useState<Landing>(undefined);
    const [languageEditing, setLanguageEditing] = useState<any>(undefined);
    const [disabledSearchForGeneralConfig, setDisabledSearchForGeneralConfig] =
        useState<boolean>(true);
    const [savingRanking, setSavingRanking] = useState<boolean>(false);
    const [statusReferral, setStatusReferral] = useState<boolean>(false);
    const [agentLanguages, setAgentLanguages] = useState<any[]>([]);
    const [savingBookingRequestFormConfig, setSavingBookingRequestFormConfig] =
        useState<boolean>(false);
    const [otherConfigurations, setOtherConfigurations] = useState<OtherConfig>({
        allowDuplicateLocatorReservations: false,
        mandatoryCompanyName: false,
        ranking: {
            showMyPositionInWebAgents: false,
            showRankingInWebAgents: false,
        },
        noIndexNoFollow: true,
        showBillingInfo: true,
        isOtpActive: false,
        blockNewBookings: false,
    });
    const [gtmId, setGtmId] = useState<string>('');

    const GetGtmIdConfig = (): void => {
        restApiClient.getGtmId().then((data) => {
            setGtmId(data);
        });
    };

    const SaveGtmId = (): void => {
        restApiClient.setGtmId(gtmId);
    };

    const [minDateCheckIn, setMinDateCheckIn] = useState<any>(null);
    const [minDateCheckInFrom, setMinDateCheckInFrom] = useState<Date>(null);
    const getMinCheckIn = (): void => {
        setLoadingParams(true);
        restApiClient
            .getMinCheckIn()
            .then((data) => {
                setMinDateCheckIn(data);
            })
            .catch((e) => {
                throw new Error(e);
            })
            .finally(() => {
                setLoadingParams(false);
            });
    };
    const getMinCheckInFrom = (): void => {
        setLoadingParams(true);
        restApiClient
            .getMinCheckInFrom()
            .then((data) => {
                console.log(new Date(data));
                setMinDateCheckInFrom(new Date(data));
            })
            .catch((e) => {
                throw new Error(e);
            })
            .finally(() => {
                setLoadingParams(false);
            });
    };

    const updateMinCheckIn = (newDate: any): void => {
        setLoadingParams(true);
        restApiClient
            .updateMinCheckIn(newDate)
            .then((data) => {
                setMinDateCheckIn(newDate);
            })
            .catch((e) => {
                throw new Error(e);
            })
            .finally(() => {
                setLoadingParams(false);
            });
    };
    const updateMinCheckInFrom = (newDate: any): void => {
        setLoadingParams(true);
        restApiClient
            .updateMinCheckInFrom(newDate)
            .then((data) => {
                setMinDateCheckInFrom(newDate);
            })
            .catch((e) => {
                throw new Error(e);
            })
            .finally(() => {
                setLoadingParams(false);
            });
    };

    const getOtherConfig = (): void => {
        setLoadingParams(true);
        restApiClient
            .getOtherConfig()
            .then((data) => {
                setOtherConfigurations(data);

                formRanking.setFieldsValue({
                    allowGeneralRanking: data?.ranking.showRankingInWebAgents,
                    allowPersonalRanking: data?.ranking.showMyPositionInWebAgents,
                });

                form.setFieldsValue({
                    allowReservations: data?.allowDuplicateLocatorReservations,
                    isMandatory: data?.mandatoryCompanyName,
                    noIndexNoFollow: data?.noIndexNoFollow,
                    isOtpActive: data?.isOtpActive,
                    blockNewBookings: data?.blockNewBookings,
                });
            })
            .catch((e) => {
                throw new Error(e);
            })
            .finally(() => {
                setLoadingParams(false);
            });
    };
    const columns = [
        {
            title: t('params.table.name'),
            key: 'positionName',
            className: 'positionName',
            render: (text, row, index) => (
                <span key={index} className="action-edit">
                    {row.positionsTranslations?.[1]?.name}
                </span>
            ),
        },
        {
            title: t('params.table.column'),
            key: 'positionTrans',
            className: 'positionTrans',
            render: (text, row, index) => (
                <span key={index} className="action-edit">
                    {row.positionsTranslations?.[0]?.name}
                </span>
            ),
        },

        {
            title: null,
            key: 'edit',
            width: '20px',
            render: (text, row, index) => (
                <span key={index} onClick={() => handleEdit(row)} className="action-edit">
                    <FontIconsCustom icon={faEdit} />
                </span>
            ),
        },
    ];

    const handleEdit = async (cell) => {
        try {
            await setSelectedPositionId(cell.id);
            await setVisibleDrawer(true);
        } catch (err) {
            alert(err.message);
        }
    };

    const handleAddRegimen = () => {
        setSelectedPositionId(null);
        setVisibleDrawer(true);
    };
    const changeStatus = async () => {
        const newStatus = !statusReferral;
        setStatusReferral(newStatus);
        await restApiClient.patchStatusReferral(newStatus);
    };
    const getEmailsNotifications = (): void => {
        restApiClient.getEmailsNotification().then((emails: EmailConfig[]) => {
            if (emails.length < 2) {
                emails.push({
                    id: uuidv4(),
                    host: '',
                    port: '',
                    enableSsl: false,
                    email: '',
                    username: '',
                    password: '',
                    useWindowsAuthentication: false,
                    defaultCfg: false,
                    isActive: false,
                });
            }
            setEmailNotificationItems(emails);
        });
    };
    useEffect(() => {
        getOtherConfig();
        getMinCheckIn();
        getMinCheckInFrom();
        restApiClient.getAgentLanguages().then((langs) => {
            setAgentLanguages(langs);
        });
        restApiClient.getStatusReferral().then((status) => {
            setStatusReferral(status);
        });
        getEmailsNotifications();
        restApiClient
            .getAcademyConfigurationGeneral()
            .then((generalData) => {
                setGeneralData(generalData);
                academyContext.updateAcademyContext(generalData);
            })
            .catch(() => {
                academyContext.updateAcademyContext({
                    academyPassword: '',
                    academyUserName: '',
                    urlAcademy: '',
                    academyIsEnabled: false,
                });
            })
            .finally(() => setDisabledSearchForGeneralConfig(false));
        restApiClient.getAvailableBalances(userLang).then((data) => {
            if (data) {
                setListExchange(data);
            }
        });
    }, []);

    const saveRankingCfg = (): void => {
        var formData = formRanking.getFieldsValue();
        setSavingRanking(true);
        restApiClient.updateRankingConfig(formData).finally(() => {
            setSavingRanking(false);
        });
    };
    function handleSave() {
        restApiClient
            .changeAcademyConfiguration(
                generalData.academyPassword,
                generalData.academyUserName,
                generalData.urlAcademy,
                generalData.academyIsEnabled,
            )
            .then(() => {
                academyContext.updateAcademyContext(generalData);
            });
    }
    const handleRender = () => {
        setLoadingSkeleton(true);
        restApiClient
            .getPositions()
            .then((data) => {
                if (data && data?.length) {
                    setDataParams((prevData) => ({
                        ...prevData,
                        positions: data,
                    }));
                } else {
                    setDataParams((prevData) => ({ ...prevData, positions: [] }));
                }
            })
            .finally(() => {
                setLoadingSkeleton(false);
            });
    };

    const [knowUsCfg, setKnowUsCfg] = useState<KnowUsCfg>({
        emailToSendBookingRequests: '',
        isEnabled: false,
        releaseDays: 1,
        sendCopyToAgent: false,
    });
    const [referralsUniqueOrPerNight, setReferralsUniqueOrPerNight] = useState<boolean>(false);
    const [knowUsCfgIsEnabled, setKnowUsCfgIsEnabled] = useState<boolean>(false);
    const [knowUsCfgSendCopyToAgent, setKnowUsCfgSendCopyToAgent] = useState<boolean>(false);
    const [knowUsCfgReleaseDays, setKnowUsCfgReleaseDays] = useState<number>(1);
    const [knowUsCfgEmailToSendBookingRequests, setKnowUsCfgEmailToSendBookingRequests] =
        useState<string>('');
    const [loadingWebConfig, setLoadingWebConfig] = useState<boolean>(false);
    const onChangeEmailNotificationDefault = (e) => {
        const value = e.target.value;
        restApiClient.updateSelectionDefault(value).then(() => {
            setEmailNotificationItems((prevEmails) =>
                prevEmails.map((email) => ({ ...email, isActive: email.id === value })),
            );
        });
    };
    const updateEmails = () => {
        restApiClient.updateEmailNotification(emailNotificationItems);
    };
    // const createNewEmailNotification = () => {
    //     restApiClient.createEmailNotification().then(() => {
    //         getEmailsNotifications();
    //     });
    // };
    // const deleteEmailNotification = (id) => {
    //     restApiClient.deleteEmailNotification(id).then(() => {
    //         getEmailsNotifications();
    //     });
    // };
    const setDataEmailNotification = (e, id, valor) => {
        const value = e.target.value;
        setEmailNotificationItems((prevEmails) =>
            prevEmails.map((email) =>
                email.id === id
                    ? { ...email, [valor]: value } // actualiza solo la propiedad indicada
                    : email,
            ),
        );
    };
    const getKnowUsConfiguration = () => {
        restApiClient.getKnowUsConfiguration('').then((r: KnowUsCfg) => {
            setKnowUsCfg(r);
            setKnowUsCfgIsEnabled(r.isEnabled);
            setKnowUsCfgSendCopyToAgent(r.sendCopyToAgent);
            setKnowUsCfgReleaseDays(r.releaseDays);
            setKnowUsCfgEmailToSendBookingRequests(r.emailToSendBookingRequests);
        });
    };
    const ChangeReferralsUniqueOrPerNight = (e) => {
        const value = e.target.value;
        restApiClient.ChangeReferralsUniqueOrPerNight(value).then(() => {
            setReferralsUniqueOrPerNight(value);
        });
    };
    const saveRequestBookingCfg = (): void => {
        const parameters: KnowUsCfg = {
            isEnabled: knowUsCfgIsEnabled,
            sendCopyToAgent: knowUsCfgSendCopyToAgent,
            emailToSendBookingRequests: knowUsCfgEmailToSendBookingRequests,
            releaseDays: knowUsCfgReleaseDays,
        };

        setSavingBookingRequestFormConfig(true);
        restApiClient.saveKnowUsCfg(parameters).finally(() => {
            setSavingBookingRequestFormConfig(false);
        });
    };

    // IMAGE UPLOAD

    function toEmbedUrl(youtubeUrl) {
        if (!youtubeUrl) return '';
        try {
            const url = new URL(youtubeUrl);
            let videoId = null;

            if (url.hostname === 'youtu.be') {
                videoId = url.pathname.slice(1);
            } else if (url.hostname.includes('youtube.com')) {
                videoId = url.searchParams.get('v');
            }

            return videoId ? `https://www.youtube.com/embed/${videoId}` : '';
        } catch {
            return '';
        }
    }
    const validate = (file, t) => {
        const isImageCompatible =
            file.type === JPEG_TYPE ||
            file.type === PNG_TYPE ||
            file.type === WEBP_TYPE ||
            file.type === SVG_TYPE ||
            file.type === ICON_TYPE ||
            file.type === GIF_TYPE;

        if (!isImageCompatible) {
            showNotification('error', 'Error', t('params.edit-profile-error-upload'), 'topRight');
        }

        console.log('File size in KB:', file.size / 1024);

        const isLt2M = file.size / 1024 < 524;

        if (!isLt2M) {
            showNotification('error', 'Error', t('params.edit-profile-error-size'), 'topRight');
        }

        return isImageCompatible && isLt2M;
    };
    const addNewSection = (typeSection: 'IM' | 'VI') => {
        restApiClient.createWebConfig(typeSection).then(() => {
            getWebConfig();
        });
    };
    const uploadImage = (options, toEdit) => {
        const { onSuccess, onError, file, onProgress } = options;
        const validation = validate(file, t);
        if (validation) {
            getBase64(file).then((url) => {
                setWebConfig((prevConfig) => ({
                    ...prevConfig,
                    [toEdit]: {
                        ...prevConfig[toEdit],
                        base64Image: url,
                        imageName: file.name,
                        imageContentType: file.type,
                    },
                }));
                onSuccess(file);
            });
        } else {
            setWebConfig((prevConfig) => ({
                ...prevConfig,
                [toEdit]: {
                    ...prevConfig[toEdit],
                    base64Image: null,
                    imageName: null,
                    imageContentType: null,
                },
            }));
        }
    };
    const uploadImageToLandingTraduction = (options) => {
        const { onSuccess, onError, file, onProgress } = options;
        const validation = validate(file, t);
        if (validation) {
            getBase64(file).then((url) => {
                setWebConfig((prevConfig) => {
                    const updatedLandings = [...prevConfig.landings];
                    const findIndexLanding = updatedLandings.findIndex(
                        (x) => JSON.stringify(x) == JSON.stringify(editWebConfig),
                    );
                    const landing = {
                        ...updatedLandings[findIndexLanding],
                    };
                    const findIndexLandingTraduction = landing.landingTraduction?.findIndex(
                        (x) => x.language.id == languageEditing,
                    );
                    if (findIndexLandingTraduction >= 0) {
                        landing.landingTraduction[findIndexLandingTraduction] = {
                            ...landing.landingTraduction[findIndexLandingTraduction],
                            imageName: file.name,
                            imageContentType: file.type,
                            base64Image: url as string,
                        };
                    }

                    updatedLandings[findIndexLanding] = landing;

                    return {
                        ...prevConfig,
                        landings: updatedLandings,
                    };
                });

                onSuccess(file);
            });
        } else {
            setWebConfig((prevConfig) => {
                const updatedLandings = [...prevConfig.landings];
                const findIndexLanding = updatedLandings.findIndex(
                    (x) => JSON.stringify(x) == JSON.stringify(editWebConfig),
                );
                const landing = {
                    ...updatedLandings[findIndexLanding],
                };
                const findIndexLandingTraduction = landing.landingTraduction?.findIndex(
                    (x) => x.language.id == languageEditing,
                );
                if (findIndexLandingTraduction >= 0) {
                    landing.landingTraduction[findIndexLandingTraduction] = {
                        ...landing.landingTraduction[findIndexLandingTraduction],
                        imageName: null,
                        imageContentType: null,
                        base64Image: null,
                    };
                }

                updatedLandings[findIndexLanding] = landing;

                return {
                    ...prevConfig,
                    landings: updatedLandings,
                };
            });
        }
    };
    const moveLanding = async (index, direction) => {
        const to = index + direction;

        // 1) validar límites
        if (to < 0 || to >= webConfig.landings.length) return;
        // 2) clonar y 3) mover con splice
        const landings = [...webConfig.landings];
        const [moved] = landings.splice(index, 1);
        landings.splice(to, 0, moved);

        // 4) normalizar orderLanding
        landings.forEach((l, i) => {
            l.orderLanding = i + 1;
        });

        setWebConfig((prev) => ({ ...prev, landings: landings }));

        // si necesitas persistir:
        await restApiClient.changeOrderLandings(landings);
    };
    const getWebConfig = async (): Promise<WebbConfig> => {
        setLoadingWebConfig(true);
        let webConfigToReturn: WebbConfig = null;
        await restApiClient.getWebConfig().then((webConfig: WebbConfig) => {
            agentLanguages.forEach((lang) => {
                webConfig.landings.forEach((landing) => {
                    const newLandingTraduction: LandingTraduction = {
                        idResourceType: landing.idResourceType,
                        idHomeLanding: landing.idHomeLanding,
                        language: {
                            id: lang.id,
                            name: lang.name,
                            imageName: lang.imageName,
                            shortId: lang.shortId,
                        },
                        multimedia: null,
                        texts: {
                            title: '',
                            subtitle: '',
                            body: '',
                        },
                        link: null,
                        imageName: null,
                        base64Image: null,
                        imageContentType: null,
                    };
                    if (!landing.landingTraduction?.some((trad) => trad.language?.id === lang.id)) {
                        landing.landingTraduction.push(newLandingTraduction);
                    }
                });
            });
            webConfigToReturn = webConfig;
            setWebConfig(webConfig);
        });
        setLoadingWebConfig(false);
        return webConfigToReturn;
    };
    const onFinish = async () => {
        await restApiClient.updateWeb(webConfig);
        await getWebConfig().finally(() => {
            setEditWebConfig(undefined);
        });
    };

    const editLandingTraduction = editWebConfig?.landingTraduction?.find(
        (x) => x.language.id == languageEditing,
    );

    // The user cant send another email test for 20 seconds after sending one, to avoid spamming the email server with test emails
    const [timeToSendAnotherEmailTest, setTimeToSendAnotherEmailTest] = useState<number>(0);
    const [sendingEmailTest, setSendingEmailTest] = useState<boolean>(false);
    const [emailTo, setEmailTo] = useState<string>('');
    const trySendEmail = (): void => {
        if (emailTo) {
            setSendingEmailTest(true);
            restApiClient.trySendEmailNotification(emailTo).then(() => {
                setTimeToSendAnotherEmailTest(20);
                setEmailTo('');
            })
                .finally(() => {
                    setSendingEmailTest(false);
                });
        }
    };

    useEffect(() => {
        if (timeToSendAnotherEmailTest > 0) {
            const timer = setTimeout(() => {
                setTimeToSendAnotherEmailTest(timeToSendAnotherEmailTest - 1);
            }, 1000);
            return () => clearTimeout(timer);
        }
    }, [timeToSendAnotherEmailTest]);

    useEffect(() => {
        getKnowUsConfiguration();
        GetGtmIdConfig();
        restApiClient.GetReferralsUniqueOrPerNight().then((r: boolean) => {
            setReferralsUniqueOrPerNight(r);
        });
    }, []);

    useEffect(() => {
        handleRender();
        scroll.scrollToTop();
    }, []);

    useEffect(() => {
        getWebConfig();
    }, [agentLanguages]);

    return (
        <>
            <Modal
                okText={t('params.yes')}
                cancelText={t('params.no')}
                visible={openDeleteModalSection !== undefined}
                onOk={() => {
                    restApiClient
                        .deleteLanding(openDeleteModalSection)
                        .then(() => {
                            getWebConfig();
                        })
                        .finally(() => setOpenDeleteModalSection(undefined));
                }}
                onCancel={() => setOpenDeleteModalSection(undefined)}
                title={t('params.delete-section')}
                destroyOnClose
            >
                {t('params.message-delete-section-web')}
            </Modal>
            <Modal
                okText={t('params.yes')}
                cancelText={t('params.no')}
                visible={modalDeleteLandingTraduction !== undefined}
                onOk={() => {
                    restApiClient
                        .deleteLandingTraduction(
                            modalDeleteLandingTraduction.id,
                            modalDeleteLandingTraduction.language,
                        )
                        .then(() => {
                            getWebConfig();
                        })
                        .finally(() => {
                            setModalDeleteLandingTraduction(undefined);
                        });
                }}
                onCancel={() => setModalDeleteLandingTraduction(undefined)}
                title={t('params.delete-landing-traduction')}
                destroyOnClose
            >
                {t('params.message-delete-landing-traduction')}
            </Modal>
            <DrawerCustom
                destroyOnClose={true}
                title={
                    <header className="d-flex justify-content-between align-items-center">
                        <span className="d-block">
                            {t(`regimens.add-${selectedPositionId ? 'edit' : 'new'}`)}
                        </span>
                        {selectedPositionId && (
                            <ButtonsCustom
                                onClick={() => {
                                    try {
                                        restApiClient.deletePosition(selectedPositionId);
                                        setDataParams((prevData) => ({
                                            ...prevData,
                                            positions: prevData.positions.filter(
                                                (r) => r.id !== selectedPositionId,
                                            ),
                                        }));
                                        setVisibleDrawer(false);
                                    } catch (error) { }
                                }}
                                content={<span>{t('rooms.drawer-delete')}</span>}
                                danger={true}
                            />
                        )}
                    </header>
                }
                visible={visibleDrawer}
                setVisible={setVisibleDrawer}
                width={520}
                info={''}
                placement="right"
                closable={true}
                onClose={() => {
                    setVisibleDrawer(false);
                    setSelectedPositionId(null);
                }}
                content={
                    <EditParams
                        setId={setSelectedPositionId}
                        setDrawerChoices={setDrawerChoices}
                        drawerChoices={drawerChoices}
                        id={selectedPositionId}
                        setVisible={setVisibleDrawer}
                        reload={handleRender}
                    />
                }
            />

            <Skeleton active loading={loadingParams || loadingSkeleton}>
                <Tabs type="card">
                    <Tabs.TabPane tab={t('params.agents-type')} key="agents">
                        <div id="params" className="special-mb config-tab">
                            <div className="row col-12">
                                <div className="align-self-center">
                                    <TitleCustom level={5} text={t('params.sub-title')} />
                                </div>
                                <div className="col align-self-center buttons my-1">
                                    <ButtonsCustom
                                        class={'primary-button'}
                                        type=""
                                        htmlType={null}
                                        onClick={handleAddRegimen}
                                        size={'small'}
                                        content={
                                            <span>
                                                <FontAwesomeIcon icon={faPlus} />
                                                <strong>{t('regimens.add-new')}</strong>
                                            </span>
                                        }
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <TableCustom
                                    className="table-regimens col-12 my-4"
                                    columns={columns}
                                    dataSource={dataParams?.positions}
                                    pagination={true}
                                    bordered
                                />
                            </div>
                        </div>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={'Ranking'} key="ranking">
                        <div id="params" className="special-mb config-tab">
                            <Form layout="vertical" form={formRanking} onFinish={saveRankingCfg}>
                                <div className="params-title">
                                    <Typography.Title level={5}>
                                        Ranking
                                        <Button
                                            className="button-config"
                                            type="primary"
                                            htmlType="submit"
                                            disabled={savingRanking}
                                        >
                                            {savingRanking ? <LoadingOutlined /> : <></>}
                                            {t('params.request-booking.save')}
                                        </Button>
                                    </Typography.Title>
                                </div>
                                <Form.Item
                                    name="allowGeneralRanking"
                                    className="flex-container d-flex flex-row align-items-center justify-content-between my-3"
                                    valuePropName="checked"
                                    label={
                                        <span className="d-block">
                                            {t('params.request-booking.enabled')}
                                        </span>
                                    }
                                >
                                    <SwitchCustomPro
                                        defaultChecked={
                                            otherConfigurations.ranking.showRankingInWebAgents
                                        }
                                        checked={otherConfigurations.ranking.showRankingInWebAgents}
                                    />
                                </Form.Item>

                                <Form.Item
                                    name="allowPersonalRanking"
                                    className="flex-container d-flex flex-row align-items-center justify-content-between my-3"
                                    valuePropName="checked"
                                    initialValue={
                                        otherConfigurations.ranking.showMyPositionInWebAgents
                                    }
                                    label={
                                        <span className="d-block">
                                            {t('params.allowRankingPersonalPosition')}
                                        </span>
                                    }
                                >
                                    <SwitchCustomPro
                                        onChange={(newValue) => {
                                            //restApiClient.updateAllowPersonalRanking(newValue);
                                        }}
                                    />
                                </Form.Item>
                            </Form>
                        </div>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={t('params.request-booking.title')} key="personal">
                        <div id="params" className="special-mb config-tab">
                            <Form
                                layout="vertical"
                                form={formKowUs}
                                onFinish={saveRequestBookingCfg}
                            >
                                <div className="params-title">
                                    <Typography.Title level={5}>
                                        {t('params.request-booking.title')}
                                        <Button
                                            className="button-config"
                                            disabled={savingBookingRequestFormConfig}
                                            type="primary"
                                            htmlType="submit"
                                        >
                                            {savingBookingRequestFormConfig ? (
                                                <LoadingOutlined />
                                            ) : (
                                                <></>
                                            )}
                                            {t('params.request-booking.save')}
                                        </Button>
                                    </Typography.Title>
                                </div>

                                <Form.Item
                                    name="requestBookingEnabled"
                                    className="flex-container d-flex flex-row align-items-center justify-content-between my-3"
                                    valuePropName="checked"
                                    label={
                                        <span className="d-block">
                                            {t('params.request-booking.enabled')}
                                        </span>
                                    }
                                >
                                    <SwitchCustomPro
                                        defaultChecked={knowUsCfg.isEnabled}
                                        checked={knowUsCfg.isEnabled}
                                        onChange={setKnowUsCfgIsEnabled}
                                    />
                                </Form.Item>

                                <Form.Item
                                    name="requestBookingSendCopyToAgent"
                                    className="flex-container d-flex flex-row align-items-center justify-content-between my-3"
                                    valuePropName="checked"
                                    label={
                                        <span className="d-block">
                                            {t('params.request-booking.send-copy-to-agent')}
                                        </span>
                                    }
                                >
                                    <SwitchCustomPro
                                        disabled={!knowUsCfgIsEnabled}
                                        defaultChecked={knowUsCfg.sendCopyToAgent}
                                        checked={knowUsCfg.sendCopyToAgent}
                                        onChange={setKnowUsCfgSendCopyToAgent}
                                    />
                                </Form.Item>

                                <Form.Item
                                    name="requestBookingDestinationEmail"
                                    initialValue={knowUsCfg.emailToSendBookingRequests}
                                    className="flex-container d-flex flex-row align-items-center justify-content-between my-3"
                                    label={
                                        <span className="d-block">
                                            {t('params.request-booking.destination-email')}
                                        </span>
                                    }
                                    rules={[
                                        {
                                            message: t('validations.name'),
                                            required: knowUsCfgIsEnabled,
                                        },
                                    ]}
                                >
                                    <Input
                                        disabled={!knowUsCfgIsEnabled}
                                        value={knowUsCfg.emailToSendBookingRequests}
                                        onChange={(v: any) => {
                                            setKnowUsCfgEmailToSendBookingRequests(v.target.value);
                                        }}
                                    />
                                </Form.Item>

                                <Form.Item
                                    name="requestBookingRelease"
                                    initialValue={knowUsCfg.releaseDays ?? 7}
                                    className="flex-container d-flex flex-row align-items-center justify-content-between my-3"
                                    label={
                                        <span className="d-block">
                                            {t('params.request-booking.release')}
                                        </span>
                                    }
                                    rules={[
                                        {
                                            message: t('validations.name'),
                                            required: knowUsCfgIsEnabled,
                                        },
                                    ]}
                                >
                                    <Input
                                        disabled={!knowUsCfgIsEnabled}
                                        type="number"
                                        min={1}
                                        max={365}
                                        value={knowUsCfg.releaseDays}
                                        onChange={(v: any) => {
                                            setKnowUsCfgReleaseDays(v.target.value);
                                        }}
                                    />
                                </Form.Item>
                            </Form>
                        </div>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={t('advancedretributiontranslations:academy')} key="academy">
                        <div id="params" className="special-mb config-tab">
                            <Form
                                layout="vertical"
                                form={formKowUs}
                                onFinish={saveRequestBookingCfg}
                            >
                                <div className="params-title">
                                    <Typography.Title level={5}>
                                        {t('advancedretributiontranslations:academy')}
                                        <Button
                                            className="button-config"
                                            disabled={disabledSearchForGeneralConfig}
                                            type="primary"
                                            onClick={handleSave}
                                        >
                                            {disabledSearchForGeneralConfig ? (
                                                <LoadingOutlined />
                                            ) : (
                                                <></>
                                            )}
                                            {t('params.request-booking.save')}
                                        </Button>
                                    </Typography.Title>
                                </div>
                                <Form.Item
                                    className="flex-container d-flex flex-row align-items-center justify-content-between my-3"
                                    label={
                                        <span className="d-block">
                                            {t('params.request-booking.enabled')}
                                        </span>
                                    }
                                >
                                    <SwitchCustomPro
                                        defaultChecked={generalData.academyIsEnabled}
                                        checked={generalData.academyIsEnabled}
                                        onChange={(e) =>
                                            setGeneralData({ ...generalData, academyIsEnabled: e })
                                        }
                                    />
                                </Form.Item>
                                <Form.Item
                                    className="flex-container d-flex flex-row align-items-center justify-content-between my-3"
                                    label={
                                        <span className="d-block">
                                            {t('advancedretributiontranslations:academy-username')}
                                        </span>
                                    }
                                >
                                    {disabledSearchForGeneralConfig ? (
                                        <Skeleton.Button active shape="square" />
                                    ) : (
                                        <Input
                                            placeholder={t(
                                                'advancedretributiontranslations:academy-username',
                                            )}
                                            id="academyUser"
                                            autoComplete="new-username"
                                            name="academyUserName"
                                            value={generalData?.academyUserName}
                                            onChange={(e) =>
                                                setGeneralData({
                                                    ...generalData,
                                                    academyUserName: e.target.value,
                                                })
                                            }
                                        />
                                    )}
                                </Form.Item>
                                <Form.Item
                                    label={
                                        <span className="d-block">
                                            {t('advancedretributiontranslations:academy-password')}
                                        </span>
                                    }
                                    className="flex-container d-flex flex-row align-items-center justify-content-between my-3"
                                >
                                    {disabledSearchForGeneralConfig ? (
                                        <Skeleton.Button active shape="square" />
                                    ) : (
                                        <Input.Password
                                            placeholder={t(
                                                'advancedretributiontranslations:academy-password',
                                            )}
                                            id="academyPassword"
                                            autoComplete="new-password"
                                            name="academyPass"
                                            iconRender={(visible) =>
                                                visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                                            }
                                            value={generalData?.academyPassword}
                                            onChange={(e) =>
                                                setGeneralData({
                                                    ...generalData,
                                                    academyPassword: e.target.value,
                                                })
                                            }
                                        />
                                    )}
                                </Form.Item>
                                <Form.Item
                                    label={
                                        <span className="d-block">
                                            {t('advancedretributiontranslations:academy-url')}
                                        </span>
                                    }
                                    className="flex-container d-flex flex-row align-items-center justify-content-between my-3"
                                >
                                    {disabledSearchForGeneralConfig ? (
                                        <Skeleton.Button active shape="square" />
                                    ) : (
                                        <Input
                                            placeholder={t(
                                                'advancedretributiontranslations:academy-url',
                                            )}
                                            id="urlAcademy"
                                            name="urlAcademy"
                                            autoComplete="off"
                                            value={generalData?.urlAcademy}
                                            onChange={(e) =>
                                                setGeneralData({
                                                    ...generalData,
                                                    urlAcademy: e.target.value,
                                                })
                                            }
                                        />
                                    )}
                                </Form.Item>
                            </Form>
                        </div>
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={'Google Tags Manager (GTM)'} key="google">
                        <div id="params" className="special-mb config-tab">
                            <Form
                                layout="vertical"
                                form={formKowUs}
                                onFinish={saveRequestBookingCfg}
                            >
                                <div className="params-title">
                                    <Typography.Title level={5}>
                                        {'Google Tags Manager (GTM)'}
                                        <Button
                                            className="button-config"
                                            type="primary"
                                            onClick={SaveGtmId}
                                        >
                                            {savingRanking ? <LoadingOutlined /> : <></>}
                                            {t('params.request-booking.save')}
                                        </Button>
                                    </Typography.Title>
                                </div>

                                <Form.Item
                                    name="gtmid"
                                    initialValue={gtmId ?? ''}
                                    className="flex-container d-flex flex-row align-items-center justify-content-between my-3"
                                    label={<span className="d-block">GTM ID</span>}
                                >
                                    <Input
                                        value={gtmId}
                                        onChange={(v: any) => {
                                            setGtmId(v.target.value);
                                        }}
                                    />
                                </Form.Item>
                            </Form>
                        </div>
                    </Tabs.TabPane>
                    {/* <Tabs.TabPane tab={t("params.emails")} key="emails">
            <EmailsConfig />
          </Tabs.TabPane> */}
                    <Tabs.TabPane tab={t('params.referrals-system')} key="referraks-system">
                        <div id="params" className="special-mb config-tab">
                            <Typography.Title level={5}>
                                {t('params.referrals-system')}
                            </Typography.Title>
                            <Form layout="vertical">
                                <Form.Item
                                    className="flex-container d-flex flex-row align-items-center justify-content-between my-3"
                                    label={
                                        <span className="d-block">
                                            {t('params.request-booking.enabled')}
                                        </span>
                                    }
                                >
                                    <Switch
                                        checked={statusReferral}
                                        onChange={() => changeStatus()}
                                        defaultChecked={statusReferral}
                                    />
                                </Form.Item>
                                <Divider />
                                <Typography.Title level={5}>
                                    {t('params.referrals-modality')}
                                </Typography.Title>
                                <p>{t('params.referrals-modality-body')}</p>
                                <Form.Item className="flex-container d-flex flex-row align-items-center justify-content-between my-3 radio-referral">
                                    <Radio.Group
                                        onChange={ChangeReferralsUniqueOrPerNight}
                                        value={referralsUniqueOrPerNight}
                                    >
                                        <Radio value={true}>
                                            <p>
                                                <Trans
                                                    i18nKey={'config:params.request-booking.unique'}
                                                    components={{
                                                        strong: <strong />,
                                                    }}
                                                />
                                            </p>
                                            <Alert
                                                message={
                                                    <Trans
                                                        i18nKey={
                                                            'config:params.request-booking.unique-alert'
                                                        }
                                                        components={{
                                                            strong: <strong />,
                                                            amount: (
                                                                <FormattedNumber
                                                                    useGrouping={true}
                                                                    value={5}
                                                                    style="currency"
                                                                    currency={
                                                                        listExchange.length > 0
                                                                            ? listExchange[0]
                                                                                .idCurrency
                                                                            : 'USD'
                                                                    }
                                                                />
                                                            ),
                                                        }}
                                                    />
                                                }
                                                type="info"
                                            />
                                        </Radio>
                                        <Radio value={false}>
                                            <p>
                                                <Trans
                                                    i18nKey={
                                                        'config:params.request-booking.per-night'
                                                    }
                                                    components={{
                                                        strong: <strong />,
                                                    }}
                                                />
                                            </p>
                                            <Alert
                                                message={
                                                    <Trans
                                                        i18nKey={
                                                            'config:params.request-booking.per-night-alert'
                                                        }
                                                        components={{
                                                            strong: <strong />,
                                                            amount1: (
                                                                <FormattedNumber
                                                                    useGrouping={true}
                                                                    value={1}
                                                                    style="currency"
                                                                    currency={
                                                                        listExchange.length > 0
                                                                            ? listExchange[0]
                                                                                .idCurrency
                                                                            : 'USD'
                                                                    }
                                                                />
                                                            ),
                                                            amount2: (
                                                                <FormattedNumber
                                                                    useGrouping={true}
                                                                    value={6}
                                                                    style="currency"
                                                                    currency={
                                                                        listExchange.length > 0
                                                                            ? listExchange[0]
                                                                                .idCurrency
                                                                            : 'USD'
                                                                    }
                                                                />
                                                            ),
                                                        }}
                                                    />
                                                }
                                                type="info"
                                            />
                                        </Radio>
                                    </Radio.Group>
                                </Form.Item>
                            </Form>
                        </div>
                    </Tabs.TabPane>
                    {webConfig != null && (
                        <Tabs.TabPane tab={t('params.web-config')} key="web-config">
                            <Skeleton active loading={loadingWebConfig}>
                                {!editWebConfig ? (
                                    <div id="params" className="special-mb config-tab">
                                        <div
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <Typography.Title level={5}>
                                                {t('params.web-config')}
                                            </Typography.Title>
                                            <ButtonsCustom
                                                class="button-config"
                                                type="primary"
                                                onClick={onFinish}
                                                content={
                                                    <span>{t('params.request-booking.save')}</span>
                                                }
                                            />
                                        </div>

                                        <FormCustom
                                            className="web-config-form"
                                            form={formWeb}
                                            layout="vertical"
                                            id="edit-web-config"
                                        >
                                            <Form.Item
                                                className="web-config-item"
                                                valuePropName="checked"
                                                label={
                                                    <>
                                                        <span className="d-block">
                                                            {t('params.favicon')}
                                                        </span>
                                                        <p
                                                            style={{
                                                                color: 'gray',
                                                                fontWeight: 400,
                                                                marginTop: 5,
                                                                marginBottom: 0,
                                                            }}
                                                        >
                                                            {t('params.favicon-description')}
                                                        </p>
                                                    </>
                                                }
                                            >
                                                <Upload
                                                    accept="image/png, image/svg+xml, image/x-icon"
                                                    customRequest={(options) =>
                                                        uploadImage(options, 'favicon')
                                                    }
                                                    beforeUpload={(file) => {
                                                        const validation = validate(file, t);
                                                        if (!validation) {
                                                            return Upload.LIST_IGNORE; // evita que aparezca el recuadro
                                                        }
                                                        return true;
                                                    }}
                                                    onRemove={() => {
                                                        setWebConfig((prevConfig) => ({
                                                            ...prevConfig,
                                                            favicon: {
                                                                ...prevConfig.favicon,
                                                                base64Image: null,
                                                                imageName: null,
                                                                imageContentType: null,
                                                            },
                                                        }));
                                                    }}
                                                    listType="picture-card"
                                                    className="avatar-uploader"
                                                    name="avatar-favicon"
                                                    multiple={false}
                                                >
                                                    {webConfig?.favicon.base64Image !==
                                                        null ? null : webConfig?.favicon?.link !==
                                                            null ? (
                                                        <>
                                                            <img
                                                                src={webConfig.favicon.link}
                                                                alt="favicon"
                                                                style={{
                                                                    width: '100%',
                                                                    height: '100%',
                                                                }}
                                                            />
                                                        </>
                                                    ) : (
                                                        <>{t('params.upload')}</>
                                                    )}
                                                </Upload>
                                            </Form.Item>
                                            <Form.Item
                                                className="web-config-item background-black"
                                                valuePropName="checked"
                                                label={
                                                    <>
                                                        <span className="d-block">
                                                            {t('params.logoBO')}
                                                        </span>
                                                        <p
                                                            style={{
                                                                color: 'gray',
                                                                fontWeight: 400,
                                                                marginTop: 5,
                                                                marginBottom: 0,
                                                            }}
                                                        >
                                                            {t('params.logoBO-description')}
                                                        </p>
                                                    </>
                                                }
                                            >
                                                <Upload
                                                    accept="image/png, image/svg+xml, image/webp"
                                                    customRequest={(options) =>
                                                        uploadImage(options, 'logoBO')
                                                    }
                                                    beforeUpload={(file) => {
                                                        const validation = validate(file, t);
                                                        if (!validation) {
                                                            return Upload.LIST_IGNORE; // evita que aparezca el recuadro
                                                        }
                                                        return true;
                                                    }}
                                                    onRemove={() => {
                                                        setWebConfig((prevConfig) => ({
                                                            ...prevConfig,
                                                            logoBO: {
                                                                ...prevConfig.logoBO,
                                                                base64Image: null,
                                                                imageName: null,
                                                                imageContentType: null,
                                                            },
                                                        }));
                                                    }}
                                                    listType="picture-card"
                                                    // className="avatar-uploader"
                                                    name="avatar-logoBO"
                                                    multiple={false}
                                                >
                                                    {webConfig?.logoBO.base64Image !==
                                                        null ? null : webConfig?.logoBO?.link !==
                                                            null ? (
                                                        <>
                                                            <img
                                                                src={webConfig.logoBO.link}
                                                                alt="logoBO"
                                                                style={{
                                                                    width: '100%',
                                                                    height: '100%',
                                                                }}
                                                            />
                                                        </>
                                                    ) : (
                                                        <>{t('params.upload')}</>
                                                    )}
                                                </Upload>
                                            </Form.Item>
                                            <Form.Item
                                                className="web-config-item"
                                                valuePropName="checked"
                                                label={
                                                    <>
                                                        <span className="d-block">
                                                            {t('params.logoWa')}
                                                        </span>
                                                        <p
                                                            style={{
                                                                color: 'gray',
                                                                fontWeight: 400,
                                                                marginTop: 5,
                                                                marginBottom: 0,
                                                            }}
                                                        >
                                                            {t('params.logoWa-description')}
                                                        </p>
                                                    </>
                                                }
                                            >
                                                <Upload
                                                    accept="image/png, image/svg+xml, image/webp"
                                                    customRequest={(options) =>
                                                        uploadImage(options, 'logoWa')
                                                    }
                                                    beforeUpload={(file) => {
                                                        const validation = validate(file, t);
                                                        if (!validation) {
                                                            return Upload.LIST_IGNORE; // evita que aparezca el recuadro
                                                        }
                                                        return true;
                                                    }}
                                                    onRemove={() => {
                                                        setWebConfig((prevConfig) => ({
                                                            ...prevConfig,
                                                            logoWa: {
                                                                ...prevConfig.logoWa,
                                                                base64Image: null,
                                                                imageName: null,
                                                                imageContentType: null,
                                                            },
                                                        }));
                                                    }}
                                                    listType="picture-card"
                                                    className="avatar-uploader"
                                                    name="avatar-logoWa"
                                                    multiple={false}
                                                >
                                                    {webConfig?.logoWa.base64Image !==
                                                        null ? null : webConfig?.logoWa?.link !==
                                                            null ? (
                                                        <>
                                                            <img
                                                                src={webConfig.logoWa.link}
                                                                alt="logoWa"
                                                                style={{
                                                                    width: '100%',
                                                                    height: '100%',
                                                                }}
                                                            />
                                                        </>
                                                    ) : (
                                                        <>{t('params.upload')}</>
                                                    )}
                                                </Upload>
                                            </Form.Item>
                                            <Form.Item
                                                className="web-config-item"
                                                valuePropName="checked"
                                                label={
                                                    <>
                                                        <span className="d-block">
                                                            {t('params.couponLogoEmail')}
                                                        </span>
                                                        <p
                                                            style={{
                                                                color: 'gray',
                                                                fontWeight: 400,
                                                                marginTop: 5,
                                                                marginBottom: 0,
                                                            }}
                                                        >
                                                            {t(
                                                                'params.couponLogoEmail-description',
                                                            )}
                                                        </p>
                                                    </>
                                                }
                                            >
                                                <Upload
                                                    accept="image/png, image/svg+xml, image/x-icon"
                                                    customRequest={(options) =>
                                                        uploadImage(options, 'couponLogoEmail')
                                                    }
                                                    beforeUpload={(file) => {
                                                        const validation = validate(file, t);
                                                        if (!validation) {
                                                            return Upload.LIST_IGNORE; // evita que aparezca el recuadro
                                                        }
                                                        return true;
                                                    }}
                                                    onRemove={() => {
                                                        setWebConfig((prevConfig) => ({
                                                            ...prevConfig,
                                                            couponLogoEmail: {
                                                                ...prevConfig.couponLogoEmail,
                                                                base64Image: null,
                                                                imageName: null,
                                                                imageContentType: null,
                                                            },
                                                        }));
                                                    }}
                                                    listType="picture-card"
                                                    className="avatar-uploader"
                                                    name="avatar-couponLogoEmail"
                                                    multiple={false}
                                                >
                                                    {webConfig?.couponLogoEmail.base64Image !==
                                                        null ? null : webConfig?.couponLogoEmail
                                                            ?.link !== null ? (
                                                        <>
                                                            <img
                                                                src={webConfig.couponLogoEmail.link}
                                                                alt="couponLogoEmail"
                                                                style={{ width: '100%' }}
                                                            />
                                                        </>
                                                    ) : (
                                                        <>{t('params.upload')}</>
                                                    )}
                                                </Upload>
                                            </Form.Item>
                                            <Form.Item
                                                className="web-config-item"
                                                valuePropName="checked"
                                                label={
                                                    <>
                                                        <span
                                                            style={{ textAlign: 'center' }}
                                                            className="d-block"
                                                        >
                                                            {t('params.customerLogoScreen')}
                                                        </span>
                                                        <p
                                                            style={{
                                                                color: 'gray',
                                                                fontWeight: 400,
                                                                marginTop: 5,
                                                                marginBottom: 0,
                                                            }}
                                                        >
                                                            {t(
                                                                'params.customerLogoScreen-description',
                                                            )}
                                                        </p>
                                                    </>
                                                }
                                            >
                                                <Upload
                                                    accept="image/png, image/svg+xml, image/x-icon"
                                                    customRequest={(options) =>
                                                        uploadImage(options, 'customerLogoScreen')
                                                    }
                                                    beforeUpload={(file) => {
                                                        const validation = validate(file, t);
                                                        if (!validation) {
                                                            return Upload.LIST_IGNORE; // evita que aparezca el recuadro
                                                        }
                                                        return true;
                                                    }}
                                                    onRemove={() => {
                                                        setWebConfig((prevConfig) => ({
                                                            ...prevConfig,
                                                            customerLogoScreen: {
                                                                ...prevConfig.customerLogoScreen,
                                                                base64Image: null,
                                                                imageName: null,
                                                                imageContentType: null,
                                                            },
                                                        }));
                                                    }}
                                                    listType="picture-card"
                                                    className="avatar-uploader"
                                                    name="avatar-customerLogoScreen"
                                                    multiple={false}
                                                >
                                                    {webConfig?.customerLogoScreen.base64Image !==
                                                        null ? null : webConfig?.customerLogoScreen
                                                            ?.link !== null ? (
                                                        <>
                                                            <img
                                                                src={
                                                                    webConfig.customerLogoScreen
                                                                        .link
                                                                }
                                                                alt="customerLogoScreen"
                                                                style={{ width: '100%' }}
                                                            />
                                                        </>
                                                    ) : (
                                                        <>{t('params.upload')}</>
                                                    )}
                                                </Upload>
                                            </Form.Item>
                                            <Form.Item
                                                className="web-config-item center-item"
                                                label={
                                                    <>
                                                        <span className="d-block">
                                                            {t('params.colorBo')}
                                                        </span>
                                                        <p
                                                            style={{
                                                                color: 'gray',
                                                                fontWeight: 400,
                                                                marginTop: 5,
                                                                marginBottom: 0,
                                                            }}
                                                        >
                                                            {t('params.colorBo-description')}
                                                        </p>
                                                    </>
                                                }
                                            >
                                                <input
                                                    value={webConfig?.colorBo}
                                                    type="color"
                                                    onChange={(e) => {
                                                        const newColor = e.target.value;
                                                        // Guarda el color en tu estado o haz update via API
                                                        setWebConfig((prev) => ({
                                                            ...prev,
                                                            colorBo: newColor,
                                                        }));
                                                    }}
                                                    style={{
                                                        width: '100px',
                                                        height: '32px',
                                                        border: 'none',
                                                        background: 'transparent',
                                                        cursor: 'pointer',
                                                        flex: '1',
                                                    }}
                                                />
                                            </Form.Item>
                                            <Form.Item
                                                className="web-config-item center-item"
                                                label={
                                                    <>
                                                        <span className="d-block">
                                                            {t('params.colorWa')}
                                                        </span>
                                                        <p
                                                            style={{
                                                                color: 'gray',
                                                                fontWeight: 400,
                                                                marginTop: 5,
                                                                marginBottom: 0,
                                                            }}
                                                        >
                                                            {t('params.colorWa-description')}
                                                        </p>
                                                    </>
                                                }
                                            >
                                                <input
                                                    type="color"
                                                    value={webConfig?.colorWa}
                                                    onChange={(e) => {
                                                        const newColor = e.target.value;
                                                        // Guarda el color en tu estado o haz update via API
                                                        setWebConfig((prev) => ({
                                                            ...prev,
                                                            colorWa: newColor,
                                                        }));
                                                    }}
                                                    style={{
                                                        flex: '1',
                                                        width: '100px',
                                                        height: '32px',
                                                        border: 'none',
                                                        background: 'transparent',
                                                        cursor: 'pointer',
                                                    }}
                                                />
                                            </Form.Item>

                                            <div
                                                style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    width: '100%',
                                                    gap: '20px',
                                                }}
                                            >
                                                <Form.Item
                                                    className="row-item-web-config"
                                                    label={
                                                        <span className="d-block">
                                                            {t('params.brand-name')}
                                                        </span>
                                                    }
                                                >
                                                    <Input
                                                        style={{ flex: '1' }}
                                                        value={webConfig?.brandName}
                                                        onChange={(v: any) => {
                                                            const value = v.target.value;
                                                            setWebConfig((prev) => ({
                                                                ...prev,
                                                                brandName: value,
                                                            }));
                                                        }}
                                                    />
                                                </Form.Item>
                                                <Form.Item
                                                    className="row-item-web-config"
                                                    label={
                                                        <span className="d-block">
                                                            {t('params.incentiveSiteName')}
                                                        </span>
                                                    }
                                                >
                                                    <Input
                                                        style={{ flex: '1' }}
                                                        value={webConfig?.incentiveSiteName}
                                                        onChange={(v: any) => {
                                                            const value = v.target.value;
                                                            setWebConfig((prev) => ({
                                                                ...prev,
                                                                incentiveSiteName: value,
                                                            }));
                                                        }}
                                                    />
                                                </Form.Item>
                                                <Form.Item
                                                    className="row-item-web-config"
                                                    label={
                                                        <span className="d-block">
                                                            {t('params.passwordExcel')}
                                                        </span>
                                                    }
                                                >
                                                    <Input.Password
                                                        style={{ flex: '1' }}
                                                        value={webConfig?.passwordExcel}
                                                        onChange={(v: any) => {
                                                            const value = v.target.value;
                                                            setWebConfig((prev) => ({
                                                                ...prev,
                                                                passwordExcel: value,
                                                            }));
                                                        }}
                                                    />
                                                </Form.Item>
                                                <Form.Item
                                                    className="row-item-web-config"
                                                    label={
                                                        <span className="d-block">
                                                            {t('params.email')}
                                                        </span>
                                                    }
                                                >
                                                    <Input
                                                        style={{ flex: '1' }}
                                                        value={webConfig?.email}
                                                        onChange={(v: any) => {
                                                            const value = v.target.value;
                                                            setWebConfig((prev) => ({
                                                                ...prev,
                                                                email: value,
                                                            }));
                                                        }}
                                                    />
                                                </Form.Item>
                                                <Form.Item
                                                    className="row-item-web-config"
                                                    label={
                                                        <span className="d-block">
                                                            {t('params.emailInvoice')}
                                                        </span>
                                                    }
                                                >
                                                    <Input
                                                        style={{ flex: '1' }}
                                                        value={webConfig?.emailInvoice}
                                                        onChange={(v: any) => {
                                                            const value = v.target.value;
                                                            setWebConfig((prev) => ({
                                                                ...prev,
                                                                emailInvoice: value,
                                                            }));
                                                        }}
                                                    />
                                                </Form.Item>
                                            </div>
                                            <Divider />
                                            <div
                                                style={{
                                                    width: '100%',
                                                    display: 'flex',
                                                    justifyContent: 'end',
                                                }}
                                            >
                                                <ButtonsCustom
                                                    type="primary"
                                                    class="button-config"
                                                    onClick={onFinish}
                                                    content={
                                                        <span>
                                                            {t('params.request-booking.save')}
                                                        </span>
                                                    }
                                                />
                                            </div>
                                            <Typography.Title style={{ margin: 0 }} level={5}>
                                                {t('params.structure-web')}
                                            </Typography.Title>
                                            <div
                                                className="collapse-web-config"
                                                style={{ width: '100%' }}
                                            >
                                                {webConfig.landings.map(
                                                    (landing, idLandingNumber) => {
                                                        return (
                                                            <div
                                                                className="landing-item"
                                                                style={{
                                                                    border: '1px solid lightgray',
                                                                    borderRadius: '10px',
                                                                    padding: '20px',
                                                                    marginBottom: '10px',
                                                                }}
                                                                key={landing.idHomeLanding}
                                                            >
                                                                <div
                                                                    className="landing-item-header"
                                                                    style={{
                                                                        display: 'flex',
                                                                        justifyContent:
                                                                            'space-between',
                                                                        alignItems: 'center',
                                                                        width: '100%',
                                                                    }}
                                                                >
                                                                    <Typography.Title level={4}>
                                                                        {t('params.section') +
                                                                            ' ' +
                                                                            (idLandingNumber + 1)}
                                                                    </Typography.Title>

                                                                    <span>
                                                                        <Button
                                                                            size="middle"
                                                                            onClick={() => {
                                                                                setOpenDeleteModalSection(
                                                                                    landing.idHomeLanding,
                                                                                );
                                                                            }}
                                                                        >
                                                                            <FontAwesomeIcon
                                                                                color={'red'}
                                                                                icon={faTrashAlt}
                                                                            />
                                                                        </Button>

                                                                        {idLandingNumber > 0 && (
                                                                            <Button
                                                                                type="default"
                                                                                onClick={() =>
                                                                                    moveLanding(
                                                                                        idLandingNumber,
                                                                                        -1,
                                                                                    )
                                                                                }
                                                                            >
                                                                                ↑
                                                                            </Button>
                                                                        )}
                                                                        {idLandingNumber <
                                                                            webConfig.landings
                                                                                .length -
                                                                            1 && (
                                                                                <Button
                                                                                    type="default"
                                                                                    onClick={() =>
                                                                                        moveLanding(
                                                                                            idLandingNumber,
                                                                                            1,
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    ↓
                                                                                </Button>
                                                                            )}
                                                                    </span>
                                                                </div>
                                                                <Tabs defaultActiveKey="1">
                                                                    {agentLanguages.map(
                                                                        (language) => {
                                                                            const landingTraduction =
                                                                                landing.landingTraduction?.find(
                                                                                    (lt) =>
                                                                                        lt.language
                                                                                            .id ===
                                                                                        language.id,
                                                                                );

                                                                            const landingTraductionIsReady =
                                                                                landingTraduction?.link &&
                                                                                landingTraduction
                                                                                    ?.texts?.body &&
                                                                                landingTraduction
                                                                                    ?.texts
                                                                                    ?.subtitle &&
                                                                                landingTraduction
                                                                                    ?.texts?.title;
                                                                            return (
                                                                                <>
                                                                                    <Tabs.TabPane
                                                                                        tab={
                                                                                            <div
                                                                                                style={{
                                                                                                    display:
                                                                                                        'flex',
                                                                                                    gap: '5px',
                                                                                                    alignItems:
                                                                                                        'center',
                                                                                                }}
                                                                                            >
                                                                                                <img
                                                                                                    height={
                                                                                                        15
                                                                                                    }
                                                                                                    src={
                                                                                                        language.imageName
                                                                                                    }
                                                                                                />

                                                                                                <p
                                                                                                    style={{
                                                                                                        margin: 0,
                                                                                                    }}
                                                                                                >
                                                                                                    {
                                                                                                        language.name
                                                                                                    }
                                                                                                </p>
                                                                                                {landingTraductionIsReady ? (
                                                                                                    <CheckCircleFilled
                                                                                                        size={
                                                                                                            10
                                                                                                        }
                                                                                                        style={{
                                                                                                            margin: 0,
                                                                                                            color: '#52c41a',
                                                                                                        }}
                                                                                                    />
                                                                                                ) : (
                                                                                                    <ExclamationCircleOutlined
                                                                                                        size={
                                                                                                            10
                                                                                                        }
                                                                                                        style={{
                                                                                                            margin: 0,
                                                                                                            color: 'red',
                                                                                                        }}
                                                                                                    />
                                                                                                )}
                                                                                            </div>
                                                                                        }
                                                                                        key={
                                                                                            language.name +
                                                                                            landing.idHomeLanding
                                                                                        }
                                                                                    >
                                                                                        <div
                                                                                            className="col-12"
                                                                                            style={{
                                                                                                flexDirection:
                                                                                                    (idLandingNumber +
                                                                                                        1) %
                                                                                                        2 !==
                                                                                                        0
                                                                                                        ? 'row'
                                                                                                        : 'row-reverse',

                                                                                                padding: 20,
                                                                                                borderBottomLeftRadius: 10,
                                                                                                borderBottomRightRadius: 10,
                                                                                                display:
                                                                                                    'flex',
                                                                                                flexWrap:
                                                                                                    'wrap-reverse',
                                                                                                gap: '20px',
                                                                                                justifyContent:
                                                                                                    'space-between',
                                                                                                position:
                                                                                                    'relative',
                                                                                            }}
                                                                                        >
                                                                                            <div
                                                                                                style={{
                                                                                                    position:
                                                                                                        'absolute',
                                                                                                    top: 10,
                                                                                                    right: 10,
                                                                                                }}
                                                                                            >
                                                                                                <PopoverCustom
                                                                                                    body={
                                                                                                        <ButtonsCustom
                                                                                                            class={
                                                                                                                'button-list-agents'
                                                                                                            }
                                                                                                            content={
                                                                                                                <FontIconsCustom
                                                                                                                    classIcon={
                                                                                                                        'icons-list-agent-register'
                                                                                                                    }
                                                                                                                    icon={
                                                                                                                        faEllipsisV
                                                                                                                    }
                                                                                                                />
                                                                                                            }
                                                                                                        />
                                                                                                    }
                                                                                                    content={
                                                                                                        <>
                                                                                                            <div
                                                                                                                className="link-menu-popover"
                                                                                                                onClick={() => {
                                                                                                                    setEditWebConfig(
                                                                                                                        landing,
                                                                                                                    );
                                                                                                                    setLanguageEditing(
                                                                                                                        language.id,
                                                                                                                    );
                                                                                                                }}
                                                                                                            >
                                                                                                                <span>
                                                                                                                    {' '}
                                                                                                                    <FontAwesomeIcon
                                                                                                                        className="icons-list-agent-register"
                                                                                                                        color={
                                                                                                                            'lightgray'
                                                                                                                        }
                                                                                                                        icon={
                                                                                                                            faEdit
                                                                                                                        }
                                                                                                                    />{' '}
                                                                                                                    {t(
                                                                                                                        'params.edit',
                                                                                                                    )}
                                                                                                                </span>
                                                                                                            </div>
                                                                                                            {landingTraductionIsReady && (
                                                                                                                <div
                                                                                                                    className="link-menu-popover"
                                                                                                                    onClick={() => {
                                                                                                                        setModalDeleteLandingTraduction(
                                                                                                                            {
                                                                                                                                id: landingTraduction.idHomeLanding,
                                                                                                                                language:
                                                                                                                                    landingTraduction
                                                                                                                                        .language
                                                                                                                                        .id,
                                                                                                                            },
                                                                                                                        );
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <span>
                                                                                                                        {' '}
                                                                                                                        <FontAwesomeIcon
                                                                                                                            className="icons-list-agent-register"
                                                                                                                            color={
                                                                                                                                'lightgray'
                                                                                                                            }
                                                                                                                            icon={
                                                                                                                                faTrashAlt
                                                                                                                            }
                                                                                                                        />{' '}
                                                                                                                        {t(
                                                                                                                            'params.delete',
                                                                                                                        )}
                                                                                                                    </span>
                                                                                                                </div>
                                                                                                            )}
                                                                                                        </>
                                                                                                    }
                                                                                                    trigger="focus"
                                                                                                />
                                                                                            </div>

                                                                                            <div
                                                                                                className="col-12 col-lg-8"
                                                                                                style={{
                                                                                                    border: 'none',
                                                                                                    flex: '1 0 60%',
                                                                                                    fontWeight: 400,
                                                                                                }}
                                                                                            >
                                                                                                <Typography.Title
                                                                                                    style={{
                                                                                                        margin: '0',
                                                                                                    }}
                                                                                                    level={
                                                                                                        3
                                                                                                    }
                                                                                                >
                                                                                                    {landingTraduction
                                                                                                        ?.texts
                                                                                                        ?.title ||
                                                                                                        t(
                                                                                                            'params.title-title',
                                                                                                        ) +
                                                                                                        ' N/A'}
                                                                                                </Typography.Title>
                                                                                                <Typography.Title
                                                                                                    style={{
                                                                                                        margin: '5px 0',
                                                                                                    }}
                                                                                                    level={
                                                                                                        4
                                                                                                    }
                                                                                                >
                                                                                                    {landingTraduction
                                                                                                        ?.texts
                                                                                                        ?.subtitle ||
                                                                                                        t(
                                                                                                            'params.subtitle-subtitle',
                                                                                                        ) +
                                                                                                        ' N/A'}
                                                                                                </Typography.Title>
                                                                                                {ReactHtmlParser(
                                                                                                    landingTraduction
                                                                                                        ?.texts
                                                                                                        ?.body ||
                                                                                                    t(
                                                                                                        'params.body-body',
                                                                                                    ) +
                                                                                                    ' N/A',
                                                                                                )}
                                                                                            </div>
                                                                                            <div
                                                                                                style={{
                                                                                                    minHeight: 210,
                                                                                                    alignItems:
                                                                                                        'center',
                                                                                                    justifyContent:
                                                                                                        'center',
                                                                                                    border: 'none',
                                                                                                    display:
                                                                                                        'flex',
                                                                                                }}
                                                                                                className="col-12 col-lg-4"
                                                                                            >
                                                                                                {landingTraduction?.link ? (
                                                                                                    <>
                                                                                                        {landingTraduction?.link?.includes(
                                                                                                            '/images/clients/',
                                                                                                        ) ? (
                                                                                                            <div
                                                                                                                style={{
                                                                                                                    width: '100%',
                                                                                                                    boxSizing:
                                                                                                                        'border-box',
                                                                                                                    height: '100%',
                                                                                                                    backgroundImage: `url(${landingTraduction?.link}) `,
                                                                                                                    backgroundPosition:
                                                                                                                        'center center',
                                                                                                                    backgroundRepeat:
                                                                                                                        'no-repeat ',
                                                                                                                    backgroundSize:
                                                                                                                        'cover',
                                                                                                                    alignItems:
                                                                                                                        'center',
                                                                                                                    justifyContent:
                                                                                                                        'center',
                                                                                                                }}
                                                                                                            />
                                                                                                        ) : (
                                                                                                            <div
                                                                                                                style={{
                                                                                                                    position:
                                                                                                                        'relative',
                                                                                                                    height: 0,
                                                                                                                    width: '100%',
                                                                                                                    overflow:
                                                                                                                        'hidden',
                                                                                                                    paddingBottom:
                                                                                                                        '55.6%',
                                                                                                                }}
                                                                                                            >
                                                                                                                <iframe
                                                                                                                    width="560"
                                                                                                                    height="315"
                                                                                                                    src={toEmbedUrl(
                                                                                                                        landingTraduction?.link,
                                                                                                                    )}
                                                                                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                                                                                    style={{
                                                                                                                        position:
                                                                                                                            'absolute',
                                                                                                                        top: 0,
                                                                                                                        left: 0,
                                                                                                                        width: '100%',
                                                                                                                        height: '100%',
                                                                                                                    }}
                                                                                                                    allowFullScreen
                                                                                                                ></iframe>
                                                                                                            </div>
                                                                                                        )}
                                                                                                    </>
                                                                                                ) : (
                                                                                                    <div
                                                                                                        style={{
                                                                                                            position:
                                                                                                                'relative',
                                                                                                            height: '100%',
                                                                                                            width: '100%',
                                                                                                            display:
                                                                                                                'flex',
                                                                                                            alignItems:
                                                                                                                'center',
                                                                                                            justifyContent:
                                                                                                                'center',
                                                                                                            border: '1px solid lightgray',
                                                                                                        }}
                                                                                                    >
                                                                                                        {t(
                                                                                                            'params.image-video',
                                                                                                        ) +
                                                                                                            ' N/A'}
                                                                                                    </div>
                                                                                                )}
                                                                                            </div>
                                                                                        </div>
                                                                                    </Tabs.TabPane>
                                                                                </>
                                                                            );
                                                                        },
                                                                    )}
                                                                </Tabs>
                                                            </div>
                                                        );
                                                    },
                                                )}
                                            </div>
                                        </FormCustom>
                                    </div>
                                ) : (
                                    <>
                                        <div className="edit-section-web-config col-12">
                                            <Button
                                                type="text"
                                                onClick={() => {
                                                    setEditWebConfig(undefined);
                                                    setWebConfig((prevConfig) => {
                                                        const updatedLandings = [
                                                            ...prevConfig.landings,
                                                        ];
                                                        const findIndexLanding =
                                                            updatedLandings.findIndex(
                                                                (x) =>
                                                                    JSON.stringify(x) ==
                                                                    JSON.stringify(editWebConfig),
                                                            );
                                                        const landing = {
                                                            ...updatedLandings[findIndexLanding],
                                                        };
                                                        const findIndexLandingTraduction =
                                                            landing.landingTraduction?.findIndex(
                                                                (x) =>
                                                                    x.language.id ==
                                                                    languageEditing,
                                                            );
                                                        if (findIndexLandingTraduction >= 0) {
                                                            landing.landingTraduction[
                                                                findIndexLandingTraduction
                                                            ] = {
                                                                ...landing.landingTraduction[
                                                                findIndexLandingTraduction
                                                                ],
                                                                imageName: null,
                                                                imageContentType: null,
                                                                base64Image: null,
                                                            };
                                                        }

                                                        updatedLandings[findIndexLanding] = landing;

                                                        return {
                                                            ...prevConfig,
                                                            landings: updatedLandings,
                                                        };
                                                    });
                                                }}
                                            >
                                                <span>
                                                    <LeftOutlined style={{ marginRight: 14 }} />
                                                    {t('params.back-section-web')}
                                                </span>
                                            </Button>
                                            <div
                                                className="col-12"
                                                style={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    width: '100%',
                                                    marginTop: 20,
                                                    flexWrap: 'wrap',
                                                }}
                                            >
                                                <div className="col-4">
                                                    {editLandingTraduction?.idResourceType ===
                                                        'IM' ? (
                                                        <>
                                                            <Upload
                                                                accept="image/png, image/svg+xml, image/x-icon"
                                                                customRequest={(options) =>
                                                                    uploadImageToLandingTraduction(
                                                                        options,
                                                                    )
                                                                }
                                                                beforeUpload={(file) => {
                                                                    const validation = validate(
                                                                        file,
                                                                        t,
                                                                    );
                                                                    if (!validation) {
                                                                        return Upload.LIST_IGNORE; // evita que aparezca el recuadro
                                                                    }
                                                                    return true;
                                                                }}
                                                                onRemove={() => {
                                                                    setWebConfig((prevConfig) => {
                                                                        const updatedLandings = [
                                                                            ...prevConfig.landings,
                                                                        ];
                                                                        const findIndexLanding =
                                                                            updatedLandings.findIndex(
                                                                                (x) =>
                                                                                    JSON.stringify(
                                                                                        x,
                                                                                    ) ==
                                                                                    JSON.stringify(
                                                                                        editWebConfig,
                                                                                    ),
                                                                            );
                                                                        const landing = {
                                                                            ...updatedLandings[
                                                                            findIndexLanding
                                                                            ],
                                                                        };
                                                                        const findIndexLandingTraduction =
                                                                            landing.landingTraduction?.findIndex(
                                                                                (x) =>
                                                                                    x.language.id ==
                                                                                    languageEditing,
                                                                            );
                                                                        if (
                                                                            findIndexLandingTraduction >=
                                                                            0
                                                                        ) {
                                                                            landing.landingTraduction[
                                                                                findIndexLandingTraduction
                                                                            ] = {
                                                                                ...landing
                                                                                    .landingTraduction[
                                                                                findIndexLandingTraduction
                                                                                ],
                                                                                imageName: null,
                                                                                imageContentType:
                                                                                    null,
                                                                                base64Image: null,
                                                                            };
                                                                        }

                                                                        updatedLandings[
                                                                            findIndexLanding
                                                                        ] = landing;

                                                                        return {
                                                                            ...prevConfig,
                                                                            landings:
                                                                                updatedLandings,
                                                                        };
                                                                    });
                                                                }}
                                                                listType="picture-card"
                                                                className="avatar-uploader"
                                                                name={`avatar`}
                                                                multiple={false}
                                                            >
                                                                {editLandingTraduction?.base64Image !==
                                                                    null ? null : editLandingTraduction?.link !==
                                                                        null ? (
                                                                    <>
                                                                        <img
                                                                            src={
                                                                                editLandingTraduction?.link
                                                                            }
                                                                            alt="landingTraduction"
                                                                            style={{
                                                                                width: '100%',
                                                                            }}
                                                                        />
                                                                    </>
                                                                ) : (
                                                                    <>{t('params.upload')}</>
                                                                )}
                                                            </Upload>
                                                            <ParagraphCustom
                                                                text={
                                                                    <strong>
                                                                        {t(
                                                                            'params.aspect-ratio-recommendation-16-9',
                                                                        )}
                                                                    </strong>
                                                                }
                                                            />
                                                            <ParagraphCustom
                                                                text={
                                                                    <strong>
                                                                        {t('params.image-size-max')}
                                                                    </strong>
                                                                }
                                                            />
                                                            <ParagraphCustom
                                                                text={
                                                                    <strong>
                                                                        {t(
                                                                            'params.image-types-permitted',
                                                                        )}
                                                                    </strong>
                                                                }
                                                            />
                                                        </>
                                                    ) : (
                                                        <>
                                                            {editLandingTraduction?.link && (
                                                                <div
                                                                    style={{
                                                                        position: 'relative',
                                                                        height: 0,
                                                                        width: '100%',
                                                                        overflow: 'hidden',
                                                                        paddingBottom: '55.6%',
                                                                    }}
                                                                >
                                                                    <iframe
                                                                        width="560"
                                                                        height="315"
                                                                        src={toEmbedUrl(
                                                                            editLandingTraduction?.link,
                                                                        )}
                                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                                        style={{
                                                                            position: 'absolute',
                                                                            top: 0,
                                                                            left: 0,
                                                                            width: '100%',
                                                                            height: '100%',
                                                                        }}
                                                                        allowFullScreen
                                                                    ></iframe>
                                                                </div>
                                                            )}
                                                            <Input
                                                                name={`link - ${editLandingTraduction?.link ||
                                                                    ''
                                                                    } `}
                                                                placeholder={t('params.video-link')}
                                                                value={editLandingTraduction?.link}
                                                                onChange={(v: any) => {
                                                                    const value = v.target.value;
                                                                    setWebConfig((prevConfig) => {
                                                                        const updatedLandings = [
                                                                            ...prevConfig.landings,
                                                                        ];
                                                                        const findIndexLanding =
                                                                            updatedLandings.findIndex(
                                                                                (x) =>
                                                                                    JSON.stringify(
                                                                                        x,
                                                                                    ) ==
                                                                                    JSON.stringify(
                                                                                        editWebConfig,
                                                                                    ),
                                                                            );
                                                                        const landing = {
                                                                            ...updatedLandings[
                                                                            findIndexLanding
                                                                            ],
                                                                        };
                                                                        const findIndexLandingTraduction =
                                                                            landing.landingTraduction?.findIndex(
                                                                                (x) =>
                                                                                    x.language.id ==
                                                                                    languageEditing,
                                                                            );
                                                                        if (
                                                                            findIndexLandingTraduction >=
                                                                            0
                                                                        ) {
                                                                            landing.landingTraduction[
                                                                                findIndexLandingTraduction
                                                                            ] = {
                                                                                ...landing
                                                                                    .landingTraduction[
                                                                                findIndexLandingTraduction
                                                                                ],
                                                                                link: value,
                                                                            };
                                                                        }
                                                                        updatedLandings[
                                                                            findIndexLanding
                                                                        ] = landing;
                                                                        return {
                                                                            ...prevConfig,
                                                                            landings:
                                                                                updatedLandings,
                                                                        };
                                                                    });
                                                                }}
                                                            />
                                                        </>
                                                    )}
                                                </div>

                                                <div
                                                    style={{
                                                        border: '1px solid lightgray',
                                                        padding: 20,
                                                        borderRadius: 10,
                                                    }}
                                                    className="col-8"
                                                >
                                                    {/* <ParagraphCustom
                                                    style={{ margin: 0 }}
                                                    class="titles"
                                                    text={<strong>{t('params.language')}</strong>}
                                                /> */}
                                                    <Typography.Title
                                                        style={{ marginTop: 5, marginBottom: 10 }}
                                                        level={4}
                                                    >
                                                        {editLandingTraduction.language.name}
                                                    </Typography.Title>
                                                    <ParagraphCustom
                                                        class="titles"
                                                        text={<strong>{t('params.title')}</strong>}
                                                    />
                                                    <Input
                                                        value={
                                                            editLandingTraduction?.texts?.title ||
                                                            ''
                                                        }
                                                        onChange={(v: any) => {
                                                            const value = v.target.value;
                                                            setWebConfig((prevConfig) => {
                                                                const updatedLandings = [
                                                                    ...prevConfig.landings,
                                                                ];
                                                                const findIndexLanding =
                                                                    updatedLandings.findIndex(
                                                                        (x) =>
                                                                            JSON.stringify(x) ==
                                                                            JSON.stringify(
                                                                                editWebConfig,
                                                                            ),
                                                                    );
                                                                const landing = {
                                                                    ...updatedLandings[
                                                                    findIndexLanding
                                                                    ],
                                                                };
                                                                const findIndexLandingTraduction =
                                                                    landing.landingTraduction?.findIndex(
                                                                        (x) =>
                                                                            x.language.id ==
                                                                            languageEditing,
                                                                    );
                                                                if (
                                                                    findIndexLandingTraduction >= 0
                                                                ) {
                                                                    landing.landingTraduction[
                                                                        findIndexLandingTraduction
                                                                    ] = {
                                                                        ...landing
                                                                            .landingTraduction[
                                                                        findIndexLandingTraduction
                                                                        ],
                                                                        texts: {
                                                                            ...landing
                                                                                .landingTraduction[
                                                                                findIndexLandingTraduction
                                                                            ].texts,
                                                                            title: value,
                                                                        },
                                                                    };
                                                                }
                                                                updatedLandings[findIndexLanding] =
                                                                    landing;
                                                                return {
                                                                    ...prevConfig,
                                                                    landings: updatedLandings,
                                                                };
                                                            });
                                                        }}
                                                    />
                                                    <ParagraphCustom
                                                        class="titles"
                                                        text={
                                                            <strong>{t('params.subtitle')}</strong>
                                                        }
                                                    />
                                                    <Input
                                                        value={
                                                            editLandingTraduction?.texts
                                                                ?.subtitle || ''
                                                        }
                                                        onChange={(v: any) => {
                                                            const value = v.target.value;
                                                            setWebConfig((prevConfig) => {
                                                                const updatedLandings = [
                                                                    ...prevConfig.landings,
                                                                ];
                                                                const findIndexLanding =
                                                                    updatedLandings.findIndex(
                                                                        (x) =>
                                                                            JSON.stringify(x) ==
                                                                            JSON.stringify(
                                                                                editWebConfig,
                                                                            ),
                                                                    );
                                                                const landing = {
                                                                    ...updatedLandings[
                                                                    findIndexLanding
                                                                    ],
                                                                };
                                                                const findIndexLandingTraduction =
                                                                    landing.landingTraduction?.findIndex(
                                                                        (x) =>
                                                                            x.language.id ==
                                                                            languageEditing,
                                                                    );
                                                                if (
                                                                    findIndexLandingTraduction >= 0
                                                                ) {
                                                                    landing.landingTraduction[
                                                                        findIndexLandingTraduction
                                                                    ] = {
                                                                        ...landing
                                                                            .landingTraduction[
                                                                        findIndexLandingTraduction
                                                                        ],
                                                                        texts: {
                                                                            ...landing
                                                                                .landingTraduction[
                                                                                findIndexLandingTraduction
                                                                            ].texts,
                                                                            subtitle: value,
                                                                        },
                                                                    };
                                                                }

                                                                updatedLandings[findIndexLanding] =
                                                                    landing;

                                                                return {
                                                                    ...prevConfig,
                                                                    landings: updatedLandings,
                                                                };
                                                            });
                                                        }}
                                                    />
                                                    <ParagraphCustom
                                                        class="titles"
                                                        text={<strong>{t('params.text')}</strong>}
                                                    />
                                                    <Editor
                                                        apiKey="l85gt2wufrhxg3vn2nhvz3nwru0at7o39z36y0ub3ylbz37q"
                                                        initialValue={
                                                            editLandingTraduction?.texts?.body || ''
                                                        }
                                                        init={{
                                                            setup: (editor) => {
                                                                editor.on('keydown', (e) => {
                                                                    const content =
                                                                        editor.getContent({
                                                                            format: 'text',
                                                                        });
                                                                    if (
                                                                        content.length >= 300 &&
                                                                        e.key.length === 1 && // evita bloquear backspace, tab, flechas, etc.
                                                                        !e.ctrlKey
                                                                    ) {
                                                                        e.preventDefault();
                                                                    }
                                                                });
                                                            },
                                                            language:
                                                                language &&
                                                                    language.lang &&
                                                                    language.lang === 'es-ES'
                                                                    ? 'es'
                                                                    : 'en_US',
                                                            height: 500,
                                                            menubar: true,
                                                            plugins: [
                                                                'code',
                                                                'lists',
                                                                'link',
                                                                'table',
                                                                'advlist',
                                                                'autolink',
                                                                'link',
                                                                'image',
                                                                'charmap',
                                                                'preview',
                                                                'anchor',
                                                                'searchreplace',
                                                                'visualblocks',
                                                                'fullscreen',
                                                                'insertdatetime',
                                                                'media',
                                                                'help',
                                                                'wordcount',
                                                            ],
                                                            toolbar:
                                                                'undo redo | formatselect | ' +
                                                                'bold italic backcolor | alignleft aligncenter ' +
                                                                'alignright alignjustify | bullist numlist outdent indent | ' +
                                                                'removeformat | code | help',
                                                        }}
                                                        onChange={(value) => {
                                                            if (value && value.target) {
                                                                setWebConfig((prevConfig) => {
                                                                    const updatedLandings = [
                                                                        ...prevConfig.landings,
                                                                    ];
                                                                    const findIndexLanding =
                                                                        updatedLandings.findIndex(
                                                                            (x) =>
                                                                                JSON.stringify(x) ==
                                                                                JSON.stringify(
                                                                                    editWebConfig,
                                                                                ),
                                                                        );
                                                                    const landing = {
                                                                        ...updatedLandings[
                                                                        findIndexLanding
                                                                        ],
                                                                    };
                                                                    const findIndexLandingTraduction =
                                                                        landing.landingTraduction?.findIndex(
                                                                            (x) =>
                                                                                x.language.id ==
                                                                                languageEditing,
                                                                        );
                                                                    if (
                                                                        findIndexLandingTraduction >=
                                                                        0
                                                                    ) {
                                                                        landing.landingTraduction[
                                                                            findIndexLandingTraduction
                                                                        ] = {
                                                                            ...landing
                                                                                .landingTraduction[
                                                                            findIndexLandingTraduction
                                                                            ],
                                                                            texts: {
                                                                                ...landing
                                                                                    .landingTraduction[
                                                                                    findIndexLandingTraduction
                                                                                ].texts,
                                                                                body: value?.target?.getContent(),
                                                                            },
                                                                        };
                                                                    }

                                                                    updatedLandings[
                                                                        findIndexLanding
                                                                    ] = landing;

                                                                    return {
                                                                        ...prevConfig,
                                                                        landings: updatedLandings,
                                                                    };
                                                                });
                                                            }
                                                            form.validateFields();
                                                        }}
                                                    />
                                                    <div
                                                        style={{
                                                            fontSize: '14px',
                                                            color: '#555',
                                                            textAlign: 'right',
                                                        }}
                                                    >
                                                        {editLandingTraduction?.texts?.body
                                                            ?.length || 0}
                                                        /{300} caracteres
                                                    </div>
                                                </div>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'end',
                                                        width: '100%',
                                                        marginTop: 20,
                                                    }}
                                                >
                                                    <ButtonsCustom
                                                        type="primary"
                                                        class="button-config"
                                                        onClick={onFinish}
                                                        content={
                                                            <span>
                                                                {t('params.request-booking.save')}
                                                            </span>
                                                        }
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                                <Divider />
                                {!editWebConfig && (
                                    <div
                                        style={{
                                            display: 'flex',
                                            gap: 10,
                                            flexWrap: 'wrap',
                                            width: '100%',
                                            justifyContent: 'end',
                                        }}
                                    >
                                        <Button
                                            className="button-config"
                                            type="primary"
                                            onClick={() => {
                                                addNewSection('IM');
                                            }}
                                        >
                                            <span
                                                style={{
                                                    display: 'flex',
                                                    gap: 20,
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <FontAwesomeIcon icon={faPlus} />{' '}
                                                {t('params.add-section-image')}
                                            </span>
                                        </Button>
                                        <Button
                                            className="button-config"
                                            type="primary"
                                            onClick={() => {
                                                addNewSection('VI');
                                            }}
                                        >
                                            <span
                                                style={{
                                                    display: 'flex',
                                                    gap: 20,
                                                    alignItems: 'center',
                                                }}
                                            >
                                                <FontAwesomeIcon icon={faPlus} />{' '}
                                                {t('params.add-section-video')}
                                            </span>
                                        </Button>
                                        <ButtonsCustom
                                            className="button-config"
                                            type="primary"
                                            onClick={onFinish}
                                            content={
                                                <span>{t('params.request-booking.save')}</span>
                                            }
                                        />
                                    </div>
                                )}
                            </Skeleton>
                        </Tabs.TabPane>
                    )}

                    <Tabs.TabPane tab={t('params.other-configurations')} key="other-configs">
                        <div id="params" className="special-mb config-tab">
                            <Typography.Title level={5}>
                                {t('params.other-configurations')}
                            </Typography.Title>

                            <FormCustom
                                onFinish={null}
                                form={form}
                                layout="vertical"
                                id="edit-channel"
                                onFieldsChange={null}
                            >
                                <Form.Item
                                    name="isMandatory"
                                    className="flex-container d-flex flex-row align-items-center justify-content-between my-3"
                                    valuePropName="checked"
                                    label={
                                        <span className="d-block">{t('params.isMandatory')}</span>
                                    }
                                >
                                    <SwitchCustomPro
                                        defaultChecked={otherConfigurations.mandatoryCompanyName}
                                        checked={otherConfigurations.mandatoryCompanyName}
                                        onChange={(newValue) => {
                                            restApiClient.updateMandatoryName(newValue);
                                        }}
                                    />
                                </Form.Item>
                                <Form.Item
                                    name="allowReservations"
                                    className="flex-container d-flex flex-row align-items-center justify-content-between my-3"
                                    valuePropName="checked"
                                    label={
                                        <span className="d-block">
                                            {t('params.allowReservations')}
                                        </span>
                                    }
                                >
                                    <SwitchCustomPro
                                        defaultChecked={
                                            otherConfigurations.allowDuplicateLocatorReservations
                                        }
                                        checked={
                                            otherConfigurations.allowDuplicateLocatorReservations
                                        }
                                        onChange={(newValue) => {
                                            restApiClient.updateAllowReservations(newValue);
                                        }}
                                    />
                                </Form.Item>
                                <Form.Item
                                    name="blockNewBookings"
                                    className="flex-container d-flex flex-row align-items-center justify-content-between my-3"
                                    valuePropName="checked"
                                    label={
                                        <span className="d-block">
                                            {t('params.blockNewBookings')}
                                        </span>
                                    }
                                >
                                    <SwitchCustomPro
                                        defaultChecked={otherConfigurations.blockNewBookings}
                                        checked={otherConfigurations.blockNewBookings}
                                        onChange={(newValue) => {
                                            restApiClient.blockNewBookings(newValue);
                                        }}
                                    />
                                </Form.Item>

                                <Form.Item
                                    name="changeCheckInDate"
                                    className="flex-container d-flex flex-row align-items-center justify-content-between my-3"
                                    valuePropName="checked"
                                    label={
                                        <span className="d-block">
                                            {t('params.set-mmin-date-value')}
                                        </span>
                                    }
                                >
                                    <InputNumber
                                        placeholder={t('translation:lang.dateFormat')}
                                        className="col-11 col-md-12"
                                        onChange={(e) => {
                                            updateMinCheckIn(e);
                                        }}
                                        style={{
                                            maxWidth: '300px',
                                            paddingRight: '0',
                                            paddingLeft: '0',
                                        }}
                                        addonAfter={t('translation:months')}
                                        value={minDateCheckIn}
                                    />
                                </Form.Item>

                                <Form.Item
                                    name="changeCheckInDate"
                                    className="flex-container d-flex flex-row align-items-center justify-content-between my-3"
                                    valuePropName="checked"
                                    label={
                                        <span className="d-block">
                                            {t('params.set-mmin-date-value-from')}
                                        </span>
                                    }
                                >
                                    <DatePicker
                                        format={local.dateFormat}
                                        locale={local}
                                        placeholder={local.lang.dateFormat}
                                        className="col-11 col-md-12"
                                        onChange={(e) => {
                                            updateMinCheckInFrom(e);
                                        }}
                                        style={{
                                            maxWidth: '300px',
                                            paddingRight: '15px',
                                            paddingLeft: '15px',
                                        }}
                                        value={
                                            minDateCheckInFrom
                                                ? moment(minDateCheckInFrom)
                                                : undefined
                                        }
                                    />
                                </Form.Item>

                                <Form.Item
                                    name="noIndexNoFollow"
                                    className="flex-container d-flex flex-row align-items-center justify-content-between my-3"
                                    valuePropName="checked"
                                    label={
                                        <span className="d-block">
                                            {t('params.set-allow-noindex-nofollow')}
                                        </span>
                                    }
                                >
                                    <SwitchCustomPro
                                        defaultChecked={otherConfigurations.noIndexNoFollow}
                                        checked={otherConfigurations.noIndexNoFollow}
                                        onChange={(newValue) => {
                                            restApiClient.updateAllowNoIndexNoFollow(newValue);
                                        }}
                                    />
                                </Form.Item>
                                <Divider />
                                <Typography.Title level={5}>
                                    {t('params.security-settings')}
                                </Typography.Title>
                                <Form.Item
                                    name="isOtpActive"
                                    className="flex-container d-flex flex-row align-items-center justify-content-between my-3"
                                    valuePropName="checked"
                                    label={
                                        <span className="d-block">{t('params.isOtpActive')}</span>
                                    }
                                >
                                    <SwitchCustomPro
                                        defaultChecked={otherConfigurations.isOtpActive}
                                        checked={otherConfigurations.isOtpActive}
                                        onChange={(newValue) => {
                                            restApiClient.updateOtpStatus(newValue);
                                        }}
                                    />
                                </Form.Item>
                                <p style={{ margin: 0, color: 'gray' }}>
                                    {t('params.otpDescription1')}
                                </p>
                                <p style={{ margin: 0, color: 'gray' }}>
                                    {t('params.otpDescription2')}
                                </p>
                                <p style={{ margin: 0, color: 'gray' }}>
                                    {t('params.otpDescription3')}
                                </p>
                                <Divider />
                                <div
                                    style={{
                                        marginTop: 20,
                                        marginBottom: 20,
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        justifyContent: 'space-between',
                                        gap: 20,
                                        width: '100%',
                                    }}
                                >
                                    <div>
                                        <Typography.Title level={5}>
                                            {t('params.email-config')}
                                        </Typography.Title>
                                        <p style={{ margin: 0, color: 'gray' }}>
                                            {t('params.email-config-description')}
                                        </p>
                                    </div>
                                    <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
                                        {/* <Button type="primary" onClick={createNewEmailNotification}>
                                            <PlusOutlined /> {t('params.new-email')}
                                        </Button> */}
                                        <Button type="primary" onClick={updateEmails}>
                                            {t('establishments.drawer-save')}
                                        </Button>
                                    </div>
                                </div>

                                <Radio.Group
                                    style={{ marginBottom: 10 }}
                                    onChange={onChangeEmailNotificationDefault}
                                    value={emailNotificationDefault}
                                >
                                    <Space direction="vertical">
                                        {emailNotificationItems?.map((item, index) => (
                                            <Radio key={item?.id + index} value={item?.id}>
                                                {item?.defaultCfg ? (
                                                    <>
                                                        {t(
                                                            'params.default-config-notifications-email',
                                                        )}
                                                    </>
                                                ) : (
                                                    <div className="email-container-notification">
                                                        <div className="email-notification-item">
                                                            <p>{t('params.email')}</p>
                                                            <Input
                                                                onChange={(e) =>
                                                                    setDataEmailNotification(
                                                                        e,
                                                                        item.id,
                                                                        'email',
                                                                    )
                                                                }
                                                                disabled={item.defaultCfg}
                                                                value={item?.email}
                                                            />
                                                        </div>
                                                        <div className="email-notification-item">
                                                            <p>{t('params.host')}</p>
                                                            <Input
                                                                onChange={(e) =>
                                                                    setDataEmailNotification(
                                                                        e,
                                                                        item.id,
                                                                        'host',
                                                                    )
                                                                }
                                                                disabled={item.defaultCfg}
                                                                value={item?.host}
                                                            />
                                                        </div>
                                                        <div className="email-notification-item">
                                                            <p>{t('params.port')}</p>
                                                            <Input
                                                                onChange={(e) =>
                                                                    setDataEmailNotification(
                                                                        e,
                                                                        item.id,
                                                                        'port',
                                                                    )
                                                                }
                                                                disabled={item.defaultCfg}
                                                                value={item?.port}
                                                            />
                                                        </div>
                                                        <div className="email-notification-item">
                                                            <p>{t('params.username')}</p>
                                                            <Input
                                                                onChange={(e) =>
                                                                    setDataEmailNotification(
                                                                        e,
                                                                        item.id,
                                                                        'username',
                                                                    )
                                                                }
                                                                disabled={item.defaultCfg}
                                                                value={item?.username}
                                                            />
                                                        </div>
                                                        <div className="email-notification-item">
                                                            <p>{t('params.password')}</p>
                                                            <Input.Password
                                                                onChange={(e) =>
                                                                    setDataEmailNotification(
                                                                        e,
                                                                        item.id,
                                                                        'password',
                                                                    )
                                                                }
                                                                disabled={item.defaultCfg}
                                                                value={item?.password}
                                                            />
                                                        </div>
                                                        <div className="email-notification-item">
                                                            <p>{t('params.ssl')}</p>
                                                            <Switch
                                                                onChange={(e) =>
                                                                    setEmailNotificationItems(
                                                                        (prevEmails) =>
                                                                            prevEmails.map(
                                                                                (email) =>
                                                                                    email.id ===
                                                                                        item.id
                                                                                        ? {
                                                                                            ...email,
                                                                                            enableSsl:
                                                                                                e,
                                                                                        } // actualiza solo la propiedad indicada
                                                                                        : email,
                                                                            ),
                                                                    )
                                                                }
                                                                disabled={item.defaultCfg}
                                                                checked={item?.enableSsl}
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                            </Radio>
                                        ))}
                                    </Space>
                                </Radio.Group>
                                <div className="email-actions">
                                    <Input
                                        disabled={sendingEmailTest || timeToSendAnotherEmailTest > 0}
                                        type="email" value={emailTo} onChange={(e) => setEmailTo(e.target.value)} className="app-input try-send-email" suffix={<Button disabled={sendingEmailTest || timeToSendAnotherEmailTest > 0} loading={sendingEmailTest} onClick={trySendEmail} type="primary" size='small' className="app-button try-send-email">{t('params.test-email')} {timeToSendAnotherEmailTest > 0 ? `(${timeToSendAnotherEmailTest})` : ''}</Button>} />
                                </div>
                                <Alert
                                    message={t('params.email-info-warning')}
                                    type="warning"
                                    showIcon
                                />
                                <Divider />
                            </FormCustom>
                        </div>
                    </Tabs.TabPane>
                </Tabs>
            </Skeleton>
        </>
    );
};
